import { useEffect, useState } from 'react';

// Shared viewport check for the mobile filter pattern. Default 720px matches
// the filter-system CSS breakpoint (index.css @media max-width: 720px) —
// distinct from 640px (table/stat density) and 900px (navbar drawer).
//
// matchMedia 'change' events fire only when the query flips, so this stays
// quiet during ordinary resizes (unlike a raw window resize listener).
export function useIsMobile(maxWidth = 720) {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(query).matches
  ));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
